module.exports = __webpack_public_path__ + "static/img/vio_ban_es.9ecce0e8.png";